@if (appRelease.newVersionAvailable()) {
    <button
        type="button"
        class="navbar-button new-version"
        data-uiid="navbar-new-version-reload"
        (click)="reloadPage()"
    >
        <i class="fas fa-sync-alt"></i>
        <span>{{ "newVersionReload" | t }}</span>
    </button>
}
